import CheckBox from '@app/components/CheckBox'
import CustomInput from '@app/components/CustomInput'
import FormGroupRenderer from '@app/components/FormGroupRenderer'
import { PriceUnits } from '@app/models/enums'
import { IPrice, Price } from '@app/models/Price'
import { IGlobalConfigurationState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import * as React from 'react'
import { Input, InputGroup, InputGroupAddon } from 'reactstrap'

interface IPriceEditorProps {
  className?: string
  name?: string
  onChange: (newPrice: Price) => void
  required?: boolean
  style?: React.CSSProperties
  value: IPrice
}

type PriceEditorProps = IPriceEditorProps & IGlobalConfigurationState

export default class PriceEditor extends React.PureComponent<PriceEditorProps> {
  constructor(props: PriceEditorProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <FormGroupRenderer
        className={this.props.className}
        style={this.props.style}
      >
        <CheckBox
          onChange={this._onChangeConfidential}
          value={this.props.value.confidential}
        >
          Price is confidential
        </CheckBox>
        <InputGroup>
          <InputGroupAddon addonType='prepend'>$</InputGroupAddon>

          <CustomInput
            type='number'
            name={this.props.name ? `${this.props.name}Amount` : undefined}
            required={this.props.required}
            step='0.01'
            value={this.props.value.amount}
            onChange={this._onChangeAmount}
          />
          <Input
            type='select'
            name={this.props.name ? `${this.props.name}Units` : undefined}
            required={this.props.required}
            value={this.props.value.units}
            onChange={this._onChangeUnits}
          >
            {this.props.configuration.priceUnits.map((key) => (
              <option key={key} value={key}>
                {humanize(key)}
              </option>
            ))}
          </Input>
        </InputGroup>
      </FormGroupRenderer>
    )
  }

  private _onChangeAmount(e: number) {
    this.props.onChange(
      new Price({
        amount: e,
        confidential: this.props.value.confidential,
        units: this.props.value.units,
      }),
    )
  }

  private _onChangeConfidential(confidential: boolean) {
    this.props.onChange(
      new Price({
        amount: this.props.value.amount,
        confidential,
        units: this.props.value.units,
      }),
    )
  }

  private _onChangeUnits(e: React.ChangeEvent<HTMLInputElement>) {
    this.props.onChange(
      new Price({
        amount: this.props.value.amount,
        confidential: this.props.value.confidential,
        units: e.target.value as PriceUnits,
      }),
    )
  }
}
